'use client';

var translations = {
    Search: 'Tìm kiếm',
    'Find your dream jobs': 'Tìm kiếm công việc mơ ước',
    'All Locations': 'Tất cả địa điểm',
    'All locations': 'Tất cả địa điểm',
    'All Province/City': 'Tất cả tỉnh/thành phố',
    'Select Province/City': 'Chọn tỉnh/thành phố',
    'You have selected up to three Province/City': 'Bạn đã chọn tối đa ba tỉnh/thành phố',
    'You have selected up to three locations': 'Bạn đã chọn tối đa ba địa điểm',
    All: 'Tất cả',
    Location: 'Địa điểm',
    Locations: 'Địa điểm',
    Apply: 'Áp dụng',
    Cancel: 'Huỷ',
    'Selected Locations': 'Địa điểm đã chọn',
    'No Result': 'Không có kết quả',
    'Search for jobs, companies, skills': 'Tìm kiếm việc làm, công ty, kỹ năng',
    'Try Searching For': 'Có Phải Bạn Đang Tìm',
    'Hot Keywords': 'Từ Khoá Phổ Biến',
    'No suggestions for': 'Không có gợi ý cho',
    'Jobs you will love': 'Việc làm bạn sẽ thích',
    Profile: 'Hồ sơ',
    Salary: 'Mức lương',
    Interview: 'Phỏng vấn',
    jobs: 'việc làm',
    job: 'việc làm',
    Job: 'Việc làm',
    Discovery: 'Khám phá',
    Company: 'Công ty',
    'Clear all': 'Xoá hết',
    'Wow CV': 'Wow CV',
    'Recent searchs': 'Tìm kiếm gần đây',
    'Prepare your interview': 'Chuẩn bị cho buổi phỏng vấn',
    'Update your resume': '	Cập nhật hồ sơ của bạn',
    'Impress recruiter': 'Gây ấn tượng với nhà tuyển dụng',
    'Know your worth': 'Tìm hiểu mức lương phù hợp',
    '/job-search/all-jobs': '/tim-viec-lam/tim-tat-ca-viec-lam',
    'You have no keyword search': 'Bạn không có tìm kiếm từ khoá nào',
    'No recent searches': 'Không có tìm kiếm gần đây',
    'Your search will be listed here in the future': 'Lịch sử từ khoá tìm kiếm của bạn sẽ được hiển thị ở đây',
    'Double check your keywords or try another search term.': 'Kiểm tra lại từ khóa hoặc thử một cụm từ tìm kiếm khác.',
    'Enter a job title to view a set of interview questions': 'Nhập chức danh để xem bộ câu hỏi phỏng vấn',
    'Enter a job title to view salary': 'Nhập chức danh để xem mức lương',
    'https://www.vietnamworks.com/my-career-center/dashboard': 'https://www.vietnamworks.com/quan-ly-nghe-nghiep/quan-ly-ho-so',
    '/my-career-center/dashboard': '/quan-ly-nghe-nghiep/quan-ly-ho-so',
    '/my-profile': '/ho-so',
    'All Districts': 'Tất cả Quận/Huyện',
    "There are no suitable job recommendations for you on VietnamWorks at the moment. We'll notify you as soon as new opportunities come up!": 'Hiện tại, chưa có gợi ý công việc phù hợp với bạn trên VietnamWorks. Chúng tôi sẽ thông báo ngay khi có cơ hội mới!'
};

export { translations as default };
//# sourceMappingURL=translation.js.map
